import React from 'react';
import { PageLoader } from 'src/lib/PageLoader';
import { IAuctionData } from 'src/pages/CatalogPage/Catalog.i';

export const AsyncCatalogPage = ({ ...props }): JSX.Element => (
  <PageLoader
    id='src/pages/Catalog'
    componentImport={async () => (await import('src/pages/CatalogPage/Catalog'))}
    head={({ backendApiFetch, location, params }) => async () => {
      try {
        // If we don't have an auction number, or our first param is something for a filter
        if(!params.p0 || isNaN(Number(params.p0))) {
          const req = await backendApiFetch('/api/auction/next');
          const res = await req.json();
          let additionalParams = ''
          Object.keys(params).forEach((key) => {
            if (typeof params[key] !== 'undefined') {
              additionalParams += `/${params[key]}`;
            }
          });
          if(location.search) {
            additionalParams += location.search;
          }
          return {
            redirect: true,
            redirectPath: `/catalog/${res[0].AuctionID}${additionalParams}`,
            redirectType: 'temporary',
          };
        }
        const auctionDataReq = await backendApiFetch(`/api/catalog/initAuctionData/${params.p0}`);
        const auctionDataRes: { AuctionData: IAuctionData, Error?: string} = await auctionDataReq.json();
        if(auctionDataRes.Error) throw new Error(auctionDataRes.Error);
        return {
          title: auctionDataRes.AuctionData.Title,
          description: `View and bid on firearms for sale in Auction ${
            auctionDataRes.AuctionData.AuctionID
          } by Rock Island Auction Company`,
          meta: [],
        };
      } catch (e) {
        if(e.message === 'Auction Not Found') {
          return {
            error404: true,
          };
        }
        throw e;
      }
    }}
    {...props}
  />
);
